import React, { useState } from 'react';
import { arztService } from '../../services/arzt.service';
import { Arzt } from '../../types';

interface DeleteArztDialogProps {
  arzt: Arzt;
  onSuccess: () => void;
  onCancel: () => void;
}

const DeleteArztDialog: React.FC<DeleteArztDialogProps> = ({ arzt, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    try {
      setLoading(true);
      setError(null);
      await arztService.deleteArzt(arzt.id);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Fehler beim Löschen des Arztes');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Arzt löschen
        </h3>
        
        <p className="text-gray-600 mb-4">
          Möchten Sie den Arzt <span className="font-semibold">{arzt.vorname} {arzt.nachname}</span> wirklich löschen?
        </p>
        
        <p className="text-sm text-gray-500 mb-6">
          Diese Aktion kann nicht rückgängig gemacht werden. Alle zugehörigen Zuweisungen werden ebenfalls gelöscht.
        </p>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Abbrechen
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? 'Löscht...' : 'Löschen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteArztDialog;
